const LEGACY_UPLOAD_HOSTS = new Set(["gbcclub.com", "www.gbcclub.com"]);

export function normalizeAvatarUrl(value?: string | null) {
  const candidate = value?.trim();
  if (!candidate) return undefined;
  try {
    const url = new URL(candidate);
    if (LEGACY_UPLOAD_HOSTS.has(url.hostname.toLowerCase()) && url.pathname.startsWith("/uploads/")) {
      url.protocol = "https:";
      url.host = "api.gbcclub.com";
      return url.toString();
    }
    return candidate;
  } catch {
    return candidate;
  }
}
